// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__mLpuz","file":"styles_file__23ihC"};